import React from "react";
import { ChangeLocation, FocusableHeader, PrintButton } from "../../components";
import { useTranslate } from "../../helpers";

export const PageHeader: React.FC<{
  totalPlans: number;
}> = ({ totalPlans }) => {
  const t = useTranslate();
  return (
    <>
      <div className="SanctionedPlansHeading">
        <div>
          <FocusableHeader
            className="PlanFilters__resultsHeader"
            text={`${totalPlans} ${
              totalPlans === 1
                ? t("sanctioned_plans_page.sanctioned_plans_singular")
                : t("sanctioned_plans_page.sanctioned_plans")
            }`}
          />
          <ChangeLocation showLocation={true} />
        </div>
        <PrintButton
          tealiumProps={{
            event_action: "Find Plans - Sanctioned Plans",
            event_label: "Print",
          }}
        />
      </div>

      <div className="SearchResults__tellMeMore">
        {t("sanctioned_plans_page.viewing_advisory")}
      </div>
    </>
  );
};
